import Approach from "@/views/public/newAccount/Approach.vue";
import RequestEmailToken from "@/views/public/newAccount/RequestEmailToken.vue";
import Register from "@/views/public/newAccount/Register.vue";
import Conditions from "@/views/public/newAccount/Conditions.vue";
import Success from "@/views/public/newAccount/Success.vue";
import RouteEnum from "@/router/RouteEnum";

export default [
    {
        path: "/inscription",
        name: RouteEnum.REGISTER,
        component: RequestEmailToken
    },
    {
        path: "/inscription/finalisation",
        name: RouteEnum.REGISTER_FORM,
        component: Register
    },
    {
        path: "/inscription/approche",
        name: RouteEnum.REGISTER_APPROACH,
        component: Approach
    },
    {
        path: "/inscription/conditions",
        name: RouteEnum.REGISTER_CONDITIONS,
        component: Conditions
    },
    {
        path: "/inscription/succes",
        name: RouteEnum.REGISTER_SUCCESS,
        component: Success
    },
];
